export const PageDataState = {
    Searchs: {
        benefits_id: {
            type: 'select',
            id: 'benefits_id',
            label: 'ประเภท',
            value: '',
            placeholder: 'ประเภท',
        },
        province_id: {
            type: 'select',
            id: 'province_id',
            label: 'จังหวัด',
            value: '',
            placeholder: 'จังหวัด',
        },
        operator_name: {
            type: 'text',
            id: 'operator_name',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        operator_name: {
            type: 'text',
            id: 'operator_name',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        target_industries_id: {
            type: 'text',
            id: 'target_industries_id',
            label: 'อุตสาหกรรมเป้าหมาย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        executive: {
            type: 'text',
            id: 'executive',
            label: 'ผู้บริหาร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        coordinator_name: {
            type: 'text',
            id: 'coordinator_name',
            label: 'ผู้ประสานงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        coordinator_phone_number: {
            type: 'text',
            id: 'coordinator_phone_number',
            label: 'เบอร์โทรติดต่อผู้ประสานงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 9,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        fax: {
            type: 'text',
            id: 'fax',
            label: 'เบอร์โทรสาร',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        logo: {
            type: 'file',
            id: 'logo',
            label: 'รูปภาพโลโก้ผู้ประกอบการ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        enterprise_contact: {
            type: 'text',
            id: 'enterprise_contact',
            label: 'หมายเลขโทรศัพท์ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 9,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        benefits_id: {
            type: 'select',
            id: 'benefits_id',
            label: 'ประเภท',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        location: {
            type: 'textarea',
            rows: 5,
            id: 'location',
            label: 'ที่ตั้ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        province_id: {
            type: 'text',
            id: 'province_id',
            label: 'จังหวัด',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 2,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        },
        district_id: {
            type: 'text',
            id: 'district_id',
            label: 'เขต / อำเภอ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 4,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        subdistrict_id: {
            type: 'text',
            id: 'subdistrict_id',
            label: 'แขวง / ตำบล',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 6,
                maxLength: 6
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'text',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}